import partGroupes from '../../utils/constants/partGroupes'

const groupPartsByGroup = (parts) => {
    return partGroupes.reduce((acc, partGroup) => {
        const type = partGroup.type
        const linemedia_group = partGroup.linemedia_group

        acc[type] = parts.filter((part) => part.group.includes(linemedia_group))

        return acc
    }, {})
}

export default groupPartsByGroup
